// libraries.
import styled from 'styled-components';
import {
  robotoRegular,
  scarpaGray500,
  scarpaGray400,
} from '@habitech/shared';

export const WrapperLogin = styled.div`
  .google {
    font-family: ${robotoRegular};
    font-size: 16px;
    font-weight: 400;
    text-align: center;
    line-height: 26px;
    color: ${scarpaGray500};
  }
  .title {
    font-family: 'Montserrat Bold', sans-serif;
    font-size: 20px;
    font-weight: 700;
    color: ${scarpaGray500};
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  
  .loading-title {
    font-family: 'Montserrat Bold', sans-serif;
    font-size: 22px;
    font-weight: 700;
    text-align: center;
    margin-bottom: 0.5rem;
    color: ${scarpaGray500};
  }
  
  .loading-subtitle {
    font-family: ${robotoRegular};
    font-size: 14px;
    font-weight: 400;
    text-align: center;
    color: ${scarpaGray400};
  }
`;
